import clsx from 'clsx';
import React from 'react';

const LandscapeProductCardPlaceholder = () => {
  return (
    <div className="skeleton">
      <div
        className={clsx(
          'flex',
          'gap-3',
          'bg-white',
          'border',
          'border-solid',
          'border-gray-100',
          'rounded',
          'p-3'
        )}
      >
        <div
          className={clsx(
            'bg-gray-100',
            'w-[72px]',
            'h-[72px]',
            '[&_img]:w-full',
            '[&_img]:aspect-square',
            '[&_img]:object-cover'
          )}
        ></div>
        <div className={clsx('flex-1')}>
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-[80px]',
              'mb-1',
              'text-sm'
            )}
          >
            &nbsp;
          </div>
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-[240px]',
              'mb-1',
              'text-sm'
            )}
          >
            &nbsp;
          </div>
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-[110px]',
              'mb-5',
              'text-sm'
            )}
          >
            &nbsp;
          </div>
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-[120px]',
              'mb-1',
              'text-h5'
            )}
          >
            &nbsp;
          </div>
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-[160px]',
              'mb-1',
              'text-sm'
            )}
          >
            &nbsp;
          </div>
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-[100px]',
              'text-sm'
            )}
          >
            &nbsp;
          </div>
        </div>
        <div className={clsx('flex', 'flex-col', 'gap-2', 'w-52')}>
          <div className={clsx('bg-gray-100', 'rounded-sm', 'h-10')}>
            &nbsp;
          </div>
          <div className={clsx('bg-gray-100', 'rounded-sm', 'h-10')}>
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandscapeProductCardPlaceholder;
